export default __webpack_public_path__ + "static/2379-da1bd1dcd17c19bbe57b5ef02094faee.gif";